import { Observable } from 'rxjs';
import { combineEpics } from 'redux-observable';
import { INIT, LOADING, SUCCESS, ERROR } from '../../utils/constants';
import { getChartReportAPI, getTableReportAPI, getExportAPI, getAllReportAPI } from './api';

export const GET_CURRENT_DATE = 'advaice/dashboard/GET_CURRENT_DATE';

export const GET_ALL_REPORT = 'advaice/dashboard/GET_ALL_REPORT';
export const GET_ALL_REPORT_SUCCESS = 'advaice/dashboard/GET_ALL_REPORT_SUCCESS';
export const GET_ALL_REPORT_ERROR = 'advaice/dashboard/GET_ALL_REPORT_ERROR';

export const GET_CHART_REPORT = 'advaice/dashboard/GET_CHART_REPORT';
export const GET_CHART_REPORT_SUCCESS = 'advaice/dashboard/GET_CHART_REPORT_SUCCESS';
export const GET_CHART_REPORT_ERROR = 'advaice/dashboard/GET_CHART_REPORT_ERROR';

export const GET_CHART_COMPARE_REPORT = 'advaice/dashboard/GET_CHART_COMPARE_REPORT';
export const GET_CHART_COMPARE_REPORT_SUCCESS = 'advaice/dashboard/GET_CHART_COMPARE_REPORT_SUCCESS';
export const GET_CHART_COMPARE_REPORT_ERROR = 'advaice/dashboard/GET_CHART_COMPARE_REPORT_ERROR';

export const GET_TABLE_REPORT = 'advaice/dashboard/GET_TABLE_REPORT';
export const GET_TABLE_REPORT_SUCCESS = 'advaice/dashboard/GET_TABLE_REPORT_SUCCESS';
export const GET_TABLE_REPORT_ERROR = 'advaice/dashboard/GET_TABLE_REPORT_ERROR';

export const GET_EXPORT = 'advaice/dashboard/GET_EXPORT';
export const GET_EXPORT_SUCCESS = 'advaice/dashboard/GET_EXPORT_SUCCESS';
export const GET_EXPORT_ERROR = 'advaice/dashboard/GET_EXPORT_ERROR';

export const RESET_CHART_COMPARE_REPORT = 'advaice/dashboard/RESET_CHART_COMPARE_REPORT';

export const RESET_CHART_REPORT = 'advaice/dashboard/RESET_CHART_REPORT';

export const SET_EVENT = 'advaice/dashboard/SET_EVENT';
export const GET_EVENT = 'advaice/dashboard/GET_EVENT';
export const UPDATE_EVENT = 'advaice/dashboard/UPDATE_EVENT';
export const RESET_EVENT = 'advaice/dashboard/RESET_EVENT';

export const SET_ADMIN_TABLE = 'advaice/dashboard/SET_ADMIN_TABLE';
export const GET_ADMIN_TABLE = 'advaice/dashboard/GET_ADMIN_TABLE';
export const UPDATE_ADMIN_TABLE = 'advaice/dashboard/UPDATE_ADMIN_TABLE';
export const UPDATE_EVENT_ADMIN_TABLE = 'advaice/dashboard/UPDATE_EVENT_ADMIN_TABLE';
export const DELETE_OLD_EVENTS_ADMIN_TABLE = 'advaice/dashboard/DELETE_OLD_EVENTS_ADMIN_TABLE';

export const SET_USER_TABLE = 'advaice/dashboard/SET_USER_TABLE';
export const GET_USER_TABLE = 'advaice/dashboard/GET_USER_TABLE';
export const UPDATE_USER_TABLE = 'advaice/dashboard/UPDATE_USER_TABLE';
export const UPDATE_EVENT_USER_TABLE = 'advaice/dashboard/UPDATE_EVENT_USER_TABLE';
export const DELETE_OLD_EVENTS_USER_TABLE = 'advaice/dashboard/UPDATE_OLD_EVENTS_USER_TABLE';


export const UPDATE_SELECTED_DATE = 'advaice/dashboard/UPDATE_SELECTED_DATE';
export const GET_SELECTED_DATE = 'advaice/dashboard/GET_SELECTED_DATE';

const initialState = {
  chartReport: [],
  chartReportStatus: INIT,
  chartReportError: '',
  chartCompareReport: [],
  chartCompareReportStatus: INIT,
  chartCompareReportError: '',
  tableReport: [],
  tableReportStatus: INIT,
  tableReportError: '',
  getExportStatus: '',
  currentDate: [],
  currentEvents: null,
  accessedEvents: null,
  adminTable: null,
  userTable: null,
  datePicker: {
    periodSwitchValue: null,
    datePickerTypeSwitchValue: null,
    startDate: null,
    endDate: null,
  },
};

export const dashboardStore = (state = initialState, action = {}) => {
  switch (action.type) {
    case DELETE_OLD_EVENTS_ADMIN_TABLE: {
      return {
        ...state,
        adminTable: state.adminTable.filter(item => item.inx !== action.payload),
      };
    }
    case UPDATE_EVENT_ADMIN_TABLE: {
      return {
        ...state,
        adminTable: state.adminTable.concat(action.payload),
      };
    }
    case UPDATE_ADMIN_TABLE: {
      return {
        ...state,
        adminTable: state.adminTable.concat(action.payload),
      };
    }
    case GET_ADMIN_TABLE: {
      return {
        ...state.adminTable,
      };
    }
    case SET_ADMIN_TABLE: {
      return {
        ...state,
        adminTable: action.payload,
      };
    }
    case SET_USER_TABLE: {
      return {
        ...state,
        userTable: action.payload,
      };
    }
    case GET_USER_TABLE: {
      return {
        ...state,
        userTable: action.payload,
      };
    }
    case UPDATE_USER_TABLE:
    {
      return {
        ...state,
        userTable: action.payload,
      };
    }
    case UPDATE_EVENT_USER_TABLE:
    {
      return {
        ...state,
        userTable: state.userTable.concat(action.payload),
      };
    }
    case DELETE_OLD_EVENTS_USER_TABLE: {
      return {
        ...state,
        userTable: state.userTable.filter(item => item.inx !== action.payload),
      };
    }
    case UPDATE_SELECTED_DATE:
    {
      return {
        ...state,
        datePicker: {
          periodSwitchValue: action.payload.interval,
          datePickerTypeSwitchValue: action.payload.parameter,
          startDate: action.payload.from,
          endDate: action.payload.to,
        },
      };
    }
    case SET_EVENT:
    {
      return {
        ...state,
        accessedEvents: action.payload.sort((a, b) => a.label.localeCompare(b.label)),
      };
    }
    case GET_EVENT:
    {
      return {
        ...state,
        accessedEvents: action.payload,
      };
    }
    case UPDATE_EVENT:
    {
      return {
        ...state,
        currentEvents: action.payload,
      };
    }
    case GET_CURRENT_DATE:
    {
      return {
        ...state,
        currentDate: action.payload,
      };
    }
    case GET_ALL_REPORT:
    {
      return {
        ...state,
        chartReportStatus: LOADING,
        tableReportStatus: LOADING,
      };
    }
    case GET_ALL_REPORT_SUCCESS:
    {
      return {
        ...state,
        chartCompareReportStatus: SUCCESS,
        tableReportStatus: SUCCESS,
        chartReport: action.payload.rChart,
        tableReport: action.payload.rTable,
        chartCompareReportError: '',
        tableReportError: '',
      };
    }
    case GET_ALL_REPORT_ERROR:
    {
      return {
        ...state,
        chartReportStatus: ERROR,
        tableReportStatus: ERROR,
        chartReportError: action.payload.rChart,
        tableReportError: action.payload.rTable,
      };
    }
    case GET_CHART_REPORT:
    {
      return {
        ...state,
        chartReportStatus: LOADING,
      };
    }
    case GET_CHART_REPORT_SUCCESS:
    {
      return {
        ...state,
        chartReportStatus: SUCCESS,
        chartReport: action.payload.data,
        chartReportError: '',
      };
    }
    case GET_CHART_REPORT_ERROR:
    {
      return {
        ...state,
        chartReportError: action.payload,
        chartReportStatus: ERROR,
      };
    }
    case GET_CHART_COMPARE_REPORT:
    {
      return {
        ...state,
        chartCompareReportStatus: LOADING,
      };
    }
    case GET_CHART_COMPARE_REPORT_SUCCESS:
    {
      return {
        ...state,
        chartCompareReportStatus: SUCCESS,
        chartCompareReport: action.payload.data,
        chartCompareReportError: '',
      };
    }
    case GET_CHART_COMPARE_REPORT_ERROR:
    {
      return {
        ...state,
        chartCompareReportError: action.payload,
        chartCompareReportStatus: ERROR,
      };
    }
    case GET_TABLE_REPORT: {
      return {
        ...state,
        tableReportStatus: LOADING,
      };
    }
    case GET_TABLE_REPORT_SUCCESS: {
      return {
        ...state,
        tableReportStatus: SUCCESS,
        tableReport: action.payload.data,
      };
    }

    case GET_EXPORT: {
      return {
        ...state,
        getExportStatus: LOADING,
      };
    }
    case GET_EXPORT_SUCCESS: {
      return {
        ...state,
        getExportStatus: SUCCESS,
      };
    }
    case RESET_CHART_REPORT: {
      return {
        ...state,
        chartReport: [],
        chartCompareReportStatus: INIT,
        chartReportError: '',
      };
    }
    case RESET_CHART_COMPARE_REPORT: {
      return {
        ...state,
        chartCompareReportStatus: INIT,
        chartCompareReport: [],
        chartCompareReportError: '',
      };
    }
    default:
    {
      return state;
    }
  }
};

export const setEvents = data => ({ type: SET_EVENT, payload: data });
export const updateEvents = data => ({ type: UPDATE_EVENT, payload: data });
export const getEvents = () => ({ type: GET_EVENT });
export const updateDatePicker = data => ({ type: UPDATE_SELECTED_DATE, payload: data });

export const setUserTable = data => ({ type: SET_USER_TABLE, payload: data });
export const getUserTable = () => ({ type: GET_USER_TABLE });
export const updateUserTable = data => ({ type: UPDATE_USER_TABLE, payload: data });
export const updateEventTableUser = data => ({
  type: UPDATE_EVENT_USER_TABLE,
  payload: data,
});
export const deleteNotActualTableUser = data => ({
  type: DELETE_OLD_EVENTS_USER_TABLE,
  payload: data,
});

export const setAdminTable = data => ({ type: SET_ADMIN_TABLE, payload: data });
export const getAdminTable = () => ({ type: GET_ADMIN_TABLE });
export const updateAdminTable = data => ({ type: UPDATE_ADMIN_TABLE, payload: data });
export const updateEventTableAdmin = data => ({
  type: UPDATE_EVENT_ADMIN_TABLE,
  payload: data,
});
export const deleteNotActualTableAdmin = data => ({
  type: DELETE_OLD_EVENTS_ADMIN_TABLE,
  payload: data,
});

export const getChartReport = data => ({ type: GET_CHART_REPORT, payload: data });

export const getAllReport = data => ({ type: GET_ALL_REPORT, payload: data });

export const getCurrentDate = data => ({ type: GET_CURRENT_DATE, payload: data });

export const getTableReport = data => ({ type: GET_TABLE_REPORT, payload: data });

export const resetChartReport = () => ({ type: RESET_CHART_REPORT });

export const resetChartCompareReport = () => ({ type: RESET_CHART_COMPARE_REPORT });

export const getExport = data => ({ type: GET_EXPORT, payload: data });

export const getChartReportObservable = (store, requestData) => Observable
  .fromPromise(getChartReportAPI(requestData))
  .map(data => ({ type: GET_CHART_REPORT_SUCCESS, payload: data }))
  .catch(err => Observable.of({ type: GET_CHART_REPORT_ERROR, payload: err }));

export const getTableReportObservable = (store, requestData) => Observable
  .fromPromise(getTableReportAPI(requestData))
  .map(data => ({ type: GET_TABLE_REPORT_SUCCESS, payload: data }))
  .catch(err => Observable.of({ type: GET_TABLE_REPORT_ERROR, payload: err }));

export const getExportObservable = (store, requestData) => Observable
  .fromPromise(getExportAPI(requestData))
  .map(data => ({ type: GET_EXPORT_SUCCESS, payload: data }))
  .catch(err => Observable.of({ type: GET_EXPORT_ERROR, payload: err }));

export const getAllReportObservable = (store, requestData) => Observable
  .fromPromise(getAllReportAPI(requestData))
  .map(data => ({ type: GET_ALL_REPORT_SUCCESS, payload: data }))
  .catch(err => Observable.of({ type: GET_ALL_REPORT_ERROR, payload: err }));

export const getChartReportEpic = (action$, store) => action$
  .ofType(GET_CHART_REPORT)
  .flatMap(action => getChartReportObservable(store, action.payload));

export const getAllReportEpic = (action$, store) => action$
  .ofType(GET_ALL_REPORT)
  .flatMap(action => getAllReportObservable(store, action.payload));


export const getTableReportEpic = (action$, store) => action$
  .ofType(GET_TABLE_REPORT)
  .flatMap(action => getTableReportObservable(store, action.payload));

export const getExportEpic = (action$, store) => action$
  .ofType(GET_EXPORT)
  .flatMap(action => getExportObservable(store, action.payload));

export const getChartCompareReport = data => ({ type: GET_CHART_COMPARE_REPORT, payload: data });

export const getChartCompareReportObservable = (store, requestData) => Observable
  .fromPromise(getChartReportAPI(requestData))
  .map(data => ({ type: GET_CHART_COMPARE_REPORT_SUCCESS, payload: data }))
  .catch(err => Observable.of({ type: GET_CHART_COMPARE_REPORT_ERROR, payload: err }));

export const getChartCompareReportEpic = (action$, store) => action$
  .ofType(GET_CHART_COMPARE_REPORT)
  .flatMap(action => getChartCompareReportObservable(store, action.payload));

export const dashboardEpic = combineEpics(
  getChartReportEpic,
  getChartCompareReportEpic,
  getTableReportEpic,
  getExportEpic,
  getAllReportEpic,
);



// WEBPACK FOOTER //
// ./src/reducers/dashboard/duck.js